/** What a Lead stage means (#907): Open, Won or Lost. The Follow up badge, the board's Won/Lost drop
 *  modals and the Won column styling read it, never the literal `won` / `lost` keys, so renaming or
 *  re-keying a stage cannot change the rule. An admin edits it per stage in both stage editors.
 *  `default_lead_outcome` in `services/lead_pipeline_config.py` and `lib/__tests__/leadStages.test.js`
 *  pin the same key defaults, so drift fails a test on either side. */
export const LEAD_OUTCOME_OPTIONS = [
    { value: 'open', label: 'Open' },
    { value: 'won', label: 'Won' },
    { value: 'lost', label: 'Lost' },
];

const OUTCOMES = new Set(LEAD_OUTCOME_OPTIONS.map((o) => o.value));

/** The outcome a stage has when none is stored: Won for the `won` key, Lost for `lost`, else Open. */
export const leadOutcomeForKey = (key) => (key === 'won' ? 'won' : key === 'lost' ? 'lost' : 'open');

/** The outcome of a stored or drafted stage. Stages saved before outcomes existed carry none, so an
 *  existing stage must be read through this, never defaulted to 'open': that would turn the
 *  `won` / `lost` stages into Open ones at the next save. Only a brand-new row starts at 'open'. */
export const leadStageOutcome = (stage) => (OUTCOMES.has(stage?.outcome) ? stage.outcome : leadOutcomeForKey(stage?.key));
